import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '../public';
import Swal from 'sweetalert2';

export const useSubgroupStore = defineStore('subgroup', {
    state: () => ({
      subgroups: [],
      hasSubgroups:[],
      totalEntries: 0,
      currentPage: 1,
      itemsPerPage: 10,
      subgroup_name: '',
      sort_by:'created_at',
      order:'desc',
    }),
    actions: {
      async fetchSubgroups(page = this.currentPage, perPage = this.itemsPerPage, subgroup_name = this.subgroup_name) {
        const url = `/api/admin/subgroup/list?per_page=${perPage}&page=${page}&subgroup_name=${subgroup_name}&sort_by=${this.sort_by}&order=${this.order}`;
        try {
          const response = await useHttp().get(url);
          this.subgroups = response.data.subgroups;
          this.totalEntries = response.data.total;
          this.currentPage = page;
          this.itemsPerPage = perPage;
          this.hasSubgroups = response.data.subgroups.filter(subgroup => subgroup.drivers_count > 0);
        } catch (error) {
          console.error('Error fetching subgroups:', error);
          throw error;
        }
      },
      async createSubgroup(payload) {
        try {
          const response = await useHttp().post('/api/admin/subgroup/create', payload);
          if (statusCheck(response.data)) {
            Swal.fire({
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.fetchSubgroups(); // 成功後刷新子群列表
          } else {
            console.log('Failed to create subgroup', 'error');
          }
        } catch (error) {
          console.error('Error creating subgroup:', error);
          throw error;
        }
      },
      async updateSubgroup(payload) {
        try {
          const response = await useHttp().post('/api/admin/subgroup/update', payload);
          if(statusCheck(response.data)){
            Swal.fire({
              icon: 'success',
              title: response.data.message ,
              showConfirmButton: false,
              timer: 1500
            });
          await this.fetchSubgroups();  // 更新後重新加載成員列表
        }
        } catch (error) {
          console.error('Error updating subgroup:', error);
          throw error;
        }
      },
      changePage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.fetchSubgroups();
        }
      },
    },
    getters: {
      paginatedData(state) {
        return state.subgroups;
      },
      totalPages(state) {
        return Math.ceil(state.totalEntries / state.itemsPerPage);
      },
    },
  });